import Logo from "@/components/tpr/Logo/Logo";
import TprIcon from "@/components/tpr/TprIcon/TprIcon";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  let navigate = useNavigate();

  return (
    <div>
      <div className="bg-white dark:bg-gray-900">
        <div className="flex justify-center h-screen">
          <div
            className="hidden bg-cover lg:block lg:w-2/3"
            style={{
              backgroundImage: `url("https://hopskotch.s3.eu-west-2.amazonaws.com/splashback/PhotoReal_abstract_pastel_oil_painting_sea_splash_sharpen_line_1.jpg")`,
              backgroundPosition: "50% 50%",
            }}
          ></div>

          <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-3/6">
            <div className="flex-1">
              {/* Logo */}
              <div className="text-center flex flex-col justify-center items-center">
                <div className="mb-4">
                  <TprIcon size="large" />
                </div>
                <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">
                  <Logo color="black" size="large" />
                </h2>

                <p className="my-8 text-gray-500 dark:text-gray-300">
                  We're sorry, we've got lost and that cannot be found.
                </p>

                <span className="text-sm text-gray-500">
                  This is likely a problem with our system if you weren't typing in a URL. If the problem persists,
                  please contact support.
                </span>

                <div className="mt-16 flex flex-col gap-4 w-full">
                  <Button variant="default" onClick={() => navigate("/login")}>
                    Login again
                  </Button>
                  <Button variant="link" onClick={() => navigate(-1)}>
                    Go back
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
